import { defineStore } from 'pinia';
import { useStoreCountry } from '~/stores/client/country';
import { strapi } from '~/stores/transport/strapi';
import { assignDataToFields, createPopulateString } from '~/utils/strapiComponents/addStrapiData';
import type { ILink } from '~/types/links';
import type { IProfileField } from '~/types/profile';

export const useStoreModalProfile = defineStore('modalProfile', {
  state: () => ({
    title: '',
    infoText: '',
    infoCompleteText: '',
    infoCompleteEstonianText: '',
    modalTwoFactorAuthText: '',
    modalTwoFactorAuthTitle: '',
    yearTitle: '',
    monthTitle: '',
    dayTitle: '',
    additionalData: '',
    errorPhoneAlreadyExists: '',
    smsCodeUndefined: '',
    receiveCodeTitle: '',
    phoneNumberIsVerified: '',
    errorPhoneNumberInvalid: '',
    errorCodeFormSend: '',
    resendCodePhone: '',
    contactSupport: '',
    profileModalLink: [] as ILink[],
    profileFields: [] as IProfileField[],
    locale: '',
    requestPromise: null as Promise<any> | null,
  }),

  getters: {
    fieldsList(state) {
      const storeCountry = useStoreCountry();

      if (storeCountry.country) {
        return state.profileFields.filter((field) => {
          if (field.excludedCountries?.split(',').includes(storeCountry.country)) {
            return false;
          } else if (
            field.includedCountries &&
            !field.includedCountries?.split(',').includes(storeCountry.country)
          ) {
            return false;
          }
          return true;
        });
      }

      return [];
    },

    fieldsTitles(state) {
      const fieldsTitles: Record<string, string> = {};

      state.profileFields.forEach((field) => {
        fieldsTitles[field.type] = field.title;
      });

      return fieldsTitles;
    },
  },

  actions: {
    async loadProfileModal() {
      if (!this.requestPromise) {
        const populateString = createPopulateString(['profileModalLink', 'profileFields']);

        this.requestPromise = strapi()
          .get('profile-modal', populateString)
          .finally(() => (this.requestPromise = null));
      }

      const response = await this.requestPromise;

      if (response?.data) {
        assignDataToFields(this, response.data);

        return true;
      } else {
        return false;
      }
    },
  },
});
